var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-button',_vm._b({attrs:{"to":_vm.to,"href":_vm.href}},'app-button',_vm.$listeners,false),[_c('app-icon',{staticClass:"return-button__icon",attrs:{"slot":"icon","value":"icon-return"},slot:"icon"}),(_vm.$slots.default)?_vm._t("default"):[_vm._v("返回")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }